import clsx from 'clsx';
import { ReactNode } from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { Icon } from '../../components/Icon/Icon';
import { Tooltip } from '../../components/Tooltip/Tooltip';
import { prepareLabel } from '../prepare-label';
import s from './InputLabel.module.scss';

interface InputLabelProps {
    field?: ControllerRenderProps<FieldValues, string>;
    labelHidden?: boolean;
    label?: string;
    id?: string;
    labelClassName?: string;
    labelTooltip?: string;
    horizontal?: boolean;
    required?: boolean;
    suppressRequiredLabel?: boolean;
    bulkMode?: boolean;
}

export function InputLabel({
    id,
    labelHidden,
    horizontal,
    labelClassName: labelClassNameProps,
    labelTooltip,
    label,
    field,
    required,
    suppressRequiredLabel,
    bulkMode,
}: InputLabelProps): ReactNode {
    if (labelHidden) {
        return null;
    }

    const labelClassName = clsx(
        labelClassNameProps,
        horizontal ? s.label : null,
        'flex gap-2',
    );
    return (
        <label htmlFor={id || field?.name} className={labelClassName}>
            {prepareLabel(
                field?.name,
                label,
                suppressRequiredLabel ? false : required,
                bulkMode,
            )}
            {labelTooltip ? (
                <>
                    <Icon id="info-icon" name="info" />
                    <Tooltip target="#info-icon">{labelTooltip}</Tooltip>
                </>
            ) : null}
        </label>
    );
}
